// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/AiCredits_KpisResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Franchise-family KPIs response — NO cost fields.
 *
 * ISP: disjoint from Admin family. Declares no provider_cost_usd / markup /
 * raw_cost_brl / margin / fx_* fields. The leak-guard (KpisContractTest)
 * asserts their absence on every row in dados.rows.
 */
import type { AiCredits_KpisRow } from './AiCredits_KpisRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface AiCredits_KpisResponseDados {
franquia_id: number
franchise_name: string
period: string
rows: AiCredits_KpisRow[]
}

export type AiCredits_KpisResponse = ApiResponse<AiCredits_KpisResponseDados>;

registerResponseContract('AiCredits_KpisResponse', {
  franquia_id:    { type: 'number',  required: true },
  franchise_name: { type: 'string',  required: true },
  period:         { type: 'string',  required: true },
  rows: {
    type: 'array',
    required: true,
    items: {
      period:       { type: 'string',  required: true },
      total_micro:  { type: 'number',  required: true },
      settle_count: { type: 'number',  required: true },
      topup_count:  { type: 'number',  required: true },
    },
  },
})
